import * as React from 'react';
export const MTSvg = React.forwardRef(function MTSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M1.998 2A2.005 2.005 0 0 0 0 4.009v7.982C0 13.101.887 14 1.998 14H8V2H1.998Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M2 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6v1H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6v1H2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M8 2v12h6.002A2.005 2.005 0 0 0 16 11.991V4.01C16 2.899 15.113 2 14.002 2H8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#CFD7DF',
        d: 'M5 5h2v2H5v2H3V7H1V5h2V3h2z',
      }),
    ),
  );
});
MTSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var MT = {
  category: 'flag',
  colorable: false,
  name: 'MT',
  svg: MTSvg,
};
